/**
 * Contact constants for the marketing site.
 *
 * Single source of truth so nav, footer, and the contact page all point at the
 * same inboxes. Both addresses are sourced from the central company/legal
 * config ({@link COMPANY}) so there is exactly one place to change them.
 *
 *   - PUBLIC_EMAIL  — the primary, public-facing inbox. Use this in the nav,
 *                     footer and as the headline contact on /contact.
 *   - FOUNDER_EMAIL — optional direct founder line. Keep it subtle (contact
 *                     page only); do not feature it prominently in every footer.
 */
import { COMPANY } from "@/lib/company";

export const PUBLIC_EMAIL = COMPANY.publicEmail;
export const FOUNDER_EMAIL = COMPANY.founderEmail;
export const FOUNDER_CALL_SUBJECT = "Talk to founder — FixControl";
export const FOUNDER_DEMO_SUBJECT = "Book a 15-min demo — FixControl";
